import { lazyModal } from '@/lib/lazy-load'

export type { NewOrgTeamModalSubmit } from './NewOrgTeamModalForm'

export const NewOrgTeamModalForm = lazyModal(() => import('./NewOrgTeamModalForm'))
